/**
 * Application Configuration
 * Centralizes environment and runtime configuration
 */

export function resolveApiBase(isServer: boolean): string {
  return isServer
    ? (process.env.SSR_API_BASE || 'http://api:8000/api')
    : (import.meta.env.VITE_API_BASE || '/api');
}

export function resolveAuthBase(isServer: boolean): string {
  return isServer
    ? (process.env.SSR_AUTH_BASE || 'http://auth:8000')
    : (import.meta.env.VITE_AUTH_BASE || 'http://localhost:8002');
}

export const config = {
  isServer: import.meta.env.SSR,
  // API base URL
  // In development, proxied through Vite to http://api:8000
  // In production, adjust based on deployment environment
  apiBase: resolveApiBase(import.meta.env.SSR),

  // Auth service public base URL (browser redirects)
  authBase: resolveAuthBase(import.meta.env.SSR),

  // Stripe configuration
  stripe: {
    publicKey: import.meta.env.VITE_STRIPE_PUBLIC_KEY || '',
  },

  // Feature flags
  features: {
    recommendations: false,
    advancedSearch: false,
  },

  // Cache configuration
  cache: {
    galleryDetailTtl: 5 * 60 * 1000, // 5 minutes
    galleryListTtl: 10 * 60 * 1000, // 10 minutes
  },
};
